import { render, staticRenderFns } from "./HeaderUserInfoRegistration.vue?vue&type=template&id=dd1bdef6"
import script from "./HeaderUserInfoRegistration.vue?vue&type=script&lang=js"
export * from "./HeaderUserInfoRegistration.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports